export const hotTips = [
  {
    id: "tip-01",
    category: "消费维权",
    title: "连锁餐饮门店后厨操作规范的投稿征集",
    summary: "多位读者反映同一品牌不同门店的操作流程存在差异，编辑部希望收集更多门店的一线观察与佐证材料。",
    heat: "高热",
    updated: "2 天前",
  },
  {
    id: "tip-02",
    category: "职场内幕",
    title: "某互联网公司试用期考核标准的知情者说",
    summary: "围绕试用期考核与转正流程，陆续收到从业者投稿，编辑部正在核对不同批次员工的时间线。",
    heat: "跟进中",
    updated: "4 天前",
  },
  {
    id: "tip-03",
    category: "行业观察",
    title: "区域供应链报价差异的线索梳理",
    summary: "同款商品在不同渠道的供货价格差距较大，投稿人希望厘清中间环节的加价逻辑。",
    heat: "核实中",
    updated: "1 周前",
  },
  {
    id: "tip-04",
    category: "教育升学",
    title: "培训课程宣传口径与实际情况的对照",
    summary: "多位家长提交了课程顾问的沟通记录，编辑部正在比对宣传材料与实际授课安排。",
    heat: "已发布",
    updated: "1 周前",
  },
  {
    id: "tip-05",
    category: "科技互联网",
    title: "应用中默认勾选与自动续费的投稿汇总",
    summary: "读者集中反映部分应用在付费流程中的默认选项设置，相关线索已进入整理阶段。",
    heat: "高热",
    updated: "5 天前",
  },
  {
    id: "tip-06",
    category: "社会民生",
    title: "老旧小区公共设施维护的线索征集",
    summary: "长期征集社区公共设施维修、费用公示等一线情况，欢迎周边居民提供时间与证据。",
    heat: "征集多",
    updated: "3 天前",
  },
];